import React from 'react';
import styled from 'styled-components/macro';
import translate from './TranslateHOC';
import { rgba } from 'polished';

function Tag({ inlineMargin, children }) {
  return <RoundedTag inlineMargin={inlineMargin}>{children}</RoundedTag>;
}

const RoundedTag = styled.span`
  ${(props) => props.theme.fontBook};
  background: ${(props) =>
    props.theme.name === 'light'
      ? rgba(props.theme.color.blackFull, 0.15)
      : rgba(props.theme.color.whiteFull, 0.15)};
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.black90
      : props.theme.color.white90};
  border-radius: 100px;
  display: inline-block;
  font-size: 18px;
  font-weight: 400;
  ${(props) => (props.inlineMargin ? `margin: 0 1em;` : `margin: 0;`)}
  height: 100%;
  letter-spacing: 0;
  padding: 2px 16px;
  position: relative;
  text-transform: uppercase;
  top: -2px;
`;

export default translate(Tag);
